<template>
  <div class="mgb10">
    <el-row>
      <el-col :span="10">
        <el-input
          v-model.trim="productNo"
          :placeholder="$t('product.productNo')"
          @blur="blurProductNo"
        />
      </el-col>
      <el-col :span="8">
        <el-select v-model.trim="color" :placeholder="$t('product.color')">
          <el-option
            v-for="c in productNoColors"
            :key="c"
            :label="c"
            :value="c"
          />
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="clickSearch">{{
          $t("action.materialSearch")
        }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Product from "@/api/product.js";
export default {
  data() {
    return {
      productNo: null,
      color: null,

      product: null,
      productNoColors: [],
      productNoColors: null,
      invSearchProductNo: null,
    };
  },

  created() {},
  methods: {
    blurProductNo() {
      const self = this;
      if (this.productNo == null || this.productNo == "") {
        return;
      }
      Product.findByProductNo({
        productNo: self.productNo,
      }).then(function (res) {
        if (res.data.code === 200) {
          self.product = res.data.entity;
          self.productNoColors = res.data.entity.colors;
        } else {
          self.$message({
            message: self.$t("prompt.productNotExist"),
            type: "warning",
          });
        }
      });
    },

    clickSearch() {
      const self = this;
      if (this.productNo == null || this.productNo == "") {
        this.$message({
          message: self.$t("prompt.fillInValidProductNo"),
          type: "warning",
        });
        return;
      }
      Product.findByProductNo({
        productNo: self.productNo,
      }).then(function (res) {
        if (res.data.code === 200) {
          self.$router.push({
            name: "mmsMaterialsSearch",
            query: {
              productNo: self.productNo,
              color: self.color,
            },
          });
        } else {
          self.$message({
            message: self.$t("prompt.productNotExist"),
            type: "warning",
          });
        }
      });
    },
  },
};
</script>